import { IMdCmFields } from "../types/AppTypes";
import { MdEnableStatusEnum } from "../types/AppEnums";

//系统标识  测试和生产主数据标识区别
export const CLIENT_APP_CODE = "assets";

export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_FIRST_PAGE_NUM = 1;
export const DEFAULT_REQUEST_TIMEOUT = 30000;

//API请求环境
const baseRequestUrl = {
	"DEV": "http://api.peijian88.cn",
	"STAGE": "http://api.beiben88.com",
	"TEST": "https://test-api-2.laoniuche.cn",
	// "TEST": "http://192.168.110.121:9059",
	"PROD": "https://api-2.yunhaogroup.com"
}

//财务的请求环境
const baseFmsRequestUrl = {
	"TESTAPI": "https://test-api-2.laoniuche.cn",
	"DEV": "http://api.peijian88.cn",
	"TEST": "https://test-api-2.laoniuche.cn",
	"PROD": "https://api-2.yunhaogroup.com",
	"STAGE": "http://api.beiben88.com"
}
//根据环境变量自动获取图片查看地址
export const getBaseImgLookUrl = (md5: string) => {
    //自动选择环境
    // return `${getBaseRequestUrl()}/fsrv/fetch/${md5}?Authorization=${getToken()}`
	return `https://fserv-priv-1301309125.cos.ap-beijing.myqcloud.com/${md5}?Authorization=${getToken()}`
}

//根据环境变量自动获取图片上传地址
export const getBaseImgUploadUrl = () => {
    //自动选择环境
    return `${getBaseRequestUrl()}/fsrv/upload_file?Authorization=${getToken()}`
}

//根据环境变量自动获取图片上传地址
export const getBaseUploadData = () => {
    return {
        appCode: CLIENT_APP_CODE,
        fileMode: 0,
    }
}
//根据环境变量自动获取请求地址
export const getBaseRequestUrl = () => {
	//自动选择环境
	//....
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
	return baseRequestUrl[REACT_APP_ENV ?? "DEV"]
};
//根据环境变量自动获取请求地址
export const getBaseFmsRequestUrl = () => {
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE" | "TESTAPI";
	return baseFmsRequestUrl[REACT_APP_ENV ?? "DEV"]
};

//服务器自定义错误码
export const INTERNAL_SERVER_ERROR_CODE = 500;
//token存储KEY值
export const TOKEN_KEY = "token";

//获取token
export const getToken = () => {
	return sessionStorage.getItem(TOKEN_KEY) ?? "default-token-str"
};

//存储token
export const setToken = (token: string) => {
	sessionStorage.setItem(TOKEN_KEY, token)
};

//通用字段定义
export const defaultMdCmParam: IMdCmFields = {
	 sourceApp: "assets",
	 sourceAuthKey: "",
	 branch: "assets",
	 ver: undefined,
	 enable: MdEnableStatusEnum.ENABLE,
	};

export const branchDs = [
	{ label: "财务分支", value: "fms" },
	{ label: "主分支", value: "main" },
	{ label: "外贸分支", value: "gtm" },
]
